/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function GoogleLogo(props) {
  return (
    <svg
      {...props}
      width="89"
      height="48"
      viewBox="0 0 89 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_18442_162843)">
        <path
          d="M37.7452 26.8146C37.7452 30.9788 34.4876 34.0472 30.4898 34.0472C26.492 34.0472 23.2344 30.9788 23.2344 26.8146C23.2344 22.6212 26.492 19.582 30.4898 19.582C34.4876 19.582 37.7452 22.6212 37.7452 26.8146ZM34.5692 26.8146C34.5692 24.2125 32.6811 22.432 30.4898 22.432C28.2985 22.432 26.4105 24.2125 26.4105 26.8146C26.4105 29.3907 28.2985 31.1972 30.4898 31.1972C32.6811 31.1972 34.5692 29.3875 34.5692 26.8146Z"
          fill="#EA4335"
        />
        <path
          d="M53.3976 26.8146C53.3976 30.9788 50.14 34.0472 46.1422 34.0472C42.1443 34.0472 38.8867 30.9788 38.8867 26.8146C38.8867 22.6244 42.1443 19.582 46.1422 19.582C50.14 19.582 53.3976 22.6212 53.3976 26.8146ZM50.2215 26.8146C50.2215 24.2125 48.3335 22.432 46.1422 22.432C43.9508 22.432 42.0628 24.2125 42.0628 26.8146C42.0628 29.3907 43.9508 31.1972 46.1422 31.1972C48.3335 31.1972 50.2215 29.3875 50.2215 26.8146Z"
          fill="#FBBC05"
        />
        <path
          d="M68.3974 20.019V33.0038C68.3974 38.3451 65.2474 40.5266 61.5235 40.5266C58.0181 40.5266 55.9083 38.182 55.1127 36.2646L57.8779 35.1136C58.3703 36.2907 59.5768 37.6799 61.5203 37.6799C63.904 37.6799 65.3811 36.2092 65.3811 33.4407V32.4005H65.2703C64.5594 33.2777 63.1898 34.044 61.4616 34.044C57.8453 34.044 54.5322 30.894 54.5322 26.8407C54.5322 22.7581 57.8453 19.582 61.4616 19.582C63.1866 19.582 64.5561 20.3483 65.2703 21.1994H65.3811V20.0222H68.3974V20.019ZM65.6061 26.8407C65.6061 24.294 63.9072 22.432 61.7453 22.432C59.554 22.432 57.7181 24.294 57.7181 26.8407C57.7181 29.3614 59.554 31.1972 61.7453 31.1972C63.9072 31.1972 65.6061 29.3614 65.6061 26.8407Z"
          fill="#4285F4"
        />
        <path
          d="M73.3708 12.4072V33.6029H70.2729V12.4072H73.3708Z"
          fill="#34A853"
        />
        <path
          d="M85.4417 29.1944L87.9069 30.8379C87.1112 32.0151 85.1938 34.0433 81.8808 34.0433C77.7721 34.0433 74.7036 30.8673 74.7036 26.8107C74.7036 22.5096 77.7982 19.5781 81.5254 19.5781C85.2786 19.5781 87.1145 22.5651 87.7145 24.1792L88.0438 25.001L78.3754 29.0053C79.1156 30.4564 80.2667 31.1966 81.8808 31.1966C83.4982 31.1966 84.6199 30.401 85.4417 29.1944ZM77.8536 26.5923L84.3167 23.9086C83.9612 23.0053 82.8917 22.376 81.633 22.376C80.0188 22.376 77.7721 23.801 77.8536 26.5923Z"
          fill="#EA4335"
        />
        <path
          d="M11.5079 24.932V21.8636H21.8481C21.9492 22.3983 22.0014 23.0309 22.0014 23.7157C22.0014 26.0179 21.372 28.8646 19.3438 30.8929C17.3709 32.9472 14.8503 34.0429 11.5112 34.0429C5.32202 34.0429 0.117676 29.0016 0.117676 22.8125C0.117676 16.6233 5.32202 11.582 11.5112 11.582C14.9351 11.582 17.3742 12.9255 19.2068 14.6766L17.0416 16.8418C15.7275 15.6092 13.947 14.6505 11.5079 14.6505C6.98833 14.6505 3.45355 18.2929 3.45355 22.8125C3.45355 27.332 6.98833 30.9744 11.5079 30.9744C14.4394 30.9744 16.109 29.7972 17.1785 28.7277C18.0459 27.8603 18.6166 26.6212 18.8416 24.9288L11.5079 24.932Z"
          fill="#4285F4"
        />
      </g>
      <defs>
        <clipPath id="clip0_18442_162843">
          <rect
            width="88.6956"
            height="30"
            fill="white"
            transform="translate(0.000488281 11.4297)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

GoogleLogo.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default GoogleLogo
